import { Component, OnInit } from '@angular/core';
import { CreateMyComplaintComponent } from '../create-my-complaint/create-my-complaint.component';

@Component({
  selector: 'app-create-complaint',
  standalone: true,
  imports: [
    CreateMyComplaintComponent
  ],
  templateUrl: './create-complaint.component.html',
  styleUrls: ['./create-complaint.component.scss']
})
export class CreateComplaintComponent implements OnInit {

  ngOnInit(): void {
  }

}
